declare global {
  interface Window {
    CustomEvent: any;
  }
}

/**
 * @hidden
 *
 * CustomEvent polyfill for IE9+
 */
const CustomEventPolyfill = (
  event: string,
  params: any = { bubbles: false, cancelable: false, detail: null }
) => {
  if (!document) {
    return;
  }
  var evt: CustomEvent = <any>document.createEvent('CustomEvent');
  evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
  return evt;
};

if (typeof Event !== 'undefined') {
  CustomEventPolyfill.prototype = Event.prototype;
}

/**
 * @hidden
 * Dispatches a logout event on the window object
 */
export const fireEvent = (
  name: string,
  params: {
    bubbles?: boolean;
    cancelable?: boolean;
    detail?: any;
  } = {}
) => {
  if (typeof window !== 'undefined') {
    if (!window.CustomEvent || typeof window.CustomEvent !== 'function') {
      window.CustomEvent = <any>CustomEventPolyfill;
    }
    const CustomEventConstructor = CustomEvent || window.CustomEvent;
    const event = new CustomEventConstructor(name, params);
    window.dispatchEvent(event);
  }
};
